<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed hide-for-print">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <div class="cell shrink">
        <router-link :to="{ name: 'ReportsList' }" class="button primary transparent">Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <router-view :key="$route.name"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Kjoperrapport',
  computed: {
    title: function () {
      return this.$route.meta.title || 'Store kunder vin'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Kjoperrapport.vue